import type { Cosmetics } from "@highmarch/app";

/**
 * How hub pages reach the cosmetics (FINISH_PLAN WP8) without new constructor arguments: features/cosmetics.ts sets
 * the link at boot (like economyLink.ts). Null in tests and before boot: a page then leaves its skin parts out.
 */
export interface SkinsLink {
  readonly cosmetics: Cosmetics;
  now(): number;
  /** Something was bought, worn or seen: save, wear it on the renderer (render/skins/wornSkins.ts), redraw the hub. */
  changed(): void;
  /** The owned tower types for the picker's strip, with their persistent level (the preview stands them at the hub's tier). */
  towers(): { id: string; name: string; level: number }[];
  baseLevel(): number;
  /** Opens the Market on the Black Market (a skin featured there today). */
  openBlackMarket(): void;
}

let link: SkinsLink | null = null;
export function setSkinsLink(l: SkinsLink | null): void { link = l; }
export function skinsLink(): SkinsLink | null { return link; }
